import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLatestRef } from "@/hooks/useLatestRef";
export function usePanelResize(t0) {
  const $ = _c(40);
  const {
    value,
    min,
    max,
    widthFromClientX,
    onCommit
  } = t0;
  let t1;
  if ($[0] !== max || $[1] !== min || $[2] !== onCommit || $[3] !== value || $[4] !== widthFromClientX) {
    t1 = {
      value,
      min,
      max,
      widthFromClientX,
      onCommit
    };
    $[0] = max;
    $[1] = min;
    $[2] = onCommit;
    $[3] = value;
    $[4] = widthFromClientX;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const config = useLatestRef(t1);
  const [dragWidth, setDragWidth] = useState(null);
  const pendingWidth = useRef(value);
  const activePointer = useRef(null);
  const frame = useRef(null);
  let t2;
  if ($[6] !== config) {
    t2 = width => {
      const current = config.current;
      return Math.max(current.min, Math.min(current.max, width));
    };
    $[6] = config;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const clamp = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (frame.current === null) {
        return;
      }
      cancelAnimationFrame(frame.current);
      frame.current = null;
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const cancelFrame = t3;
  let t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => cancelFrame;
    t5 = [cancelFrame];
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== clamp || $[12] !== config) {
    t6 = event => {
      if (event.button !== 0) {
        return;
      }
      event.preventDefault();
      activePointer.current = event.pointerId;
      pendingWidth.current = clamp(config.current.value);
      event.currentTarget.setPointerCapture(event.pointerId);
      setDragWidth(pendingWidth.current);
    };
    $[11] = clamp;
    $[12] = config;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const onPointerDown = t6;
  let t7;
  if ($[14] !== clamp || $[15] !== config) {
    t7 = event_0 => {
      if (activePointer.current !== event_0.pointerId) {
        return;
      }
      pendingWidth.current = clamp(config.current.widthFromClientX(event_0.clientX));
      if (frame.current !== null) {
        return;
      }
      frame.current = requestAnimationFrame(() => {
        setDragWidth(pendingWidth.current);
        frame.current = null;
      });
    };
    $[14] = clamp;
    $[15] = config;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const onPointerMove = t7;
  let t8;
  if ($[17] !== clamp || $[18] !== config) {
    t8 = (event_1, commit, handle) => {
      if (activePointer.current !== event_1.pointerId) {
        return;
      }
      if (commit) {
        pendingWidth.current = clamp(config.current.widthFromClientX(event_1.clientX));
        config.current.onCommit(pendingWidth.current);
      }
      cancelFrame();
      activePointer.current = null;
      if (handle?.hasPointerCapture(event_1.pointerId)) {
        handle.releasePointerCapture(event_1.pointerId);
      }
      setDragWidth(null);
    };
    $[17] = clamp;
    $[18] = config;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const finish = t8;
  const isResizing = dragWidth !== null;
  let t10;
  let t9;
  if ($[20] !== finish || $[21] !== isResizing) {
    t9 = () => {
      if (!isResizing) {
        return;
      }
      const onUp = event_2 => finish(event_2, true);
      const onCancel = event_3 => finish(event_3, false);
      document.addEventListener("pointerup", onUp);
      document.addEventListener("pointercancel", onCancel);
      return () => {
        document.removeEventListener("pointerup", onUp);
        document.removeEventListener("pointercancel", onCancel);
      };
    };
    t10 = [isResizing, finish];
    $[20] = finish;
    $[21] = isResizing;
    $[22] = t10;
    $[23] = t9;
  } else {
    t10 = $[22];
    t9 = $[23];
  }
  useEffect(t9, t10);
  let t11;
  if ($[24] !== finish) {
    t11 = event_4 => finish(event_4, true, event_4.currentTarget);
    $[24] = finish;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const onPointerUp = t11;
  let t12;
  if ($[26] !== finish) {
    t12 = event_5 => finish(event_5, false, event_5.currentTarget);
    $[26] = finish;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const onPointerCancel = t12;
  let t13;
  if ($[28] !== clamp || $[29] !== config) {
    t13 = next => config.current.onCommit(clamp(next));
    $[28] = clamp;
    $[29] = config;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const setValue = t13;
  const t14 = dragWidth ?? value;
  let t15;
  if ($[31] !== dragWidth || $[32] !== isResizing || $[33] !== onPointerCancel || $[34] !== onPointerDown || $[35] !== onPointerMove || $[36] !== onPointerUp || $[37] !== setValue || $[38] !== t14) {
    t15 = {
      value: t14,
      dragWidth,
      isResizing,
      onPointerDown,
      onPointerMove,
      onPointerUp,
      onPointerCancel,
      setValue
    };
    $[31] = dragWidth;
    $[32] = isResizing;
    $[33] = onPointerCancel;
    $[34] = onPointerDown;
    $[35] = onPointerMove;
    $[36] = onPointerUp;
    $[37] = setValue;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
}